export default __webpack_public_path__ + "static/skate-rental-9b351b346dd4459ebb7c9631ff41641b.jpg";